import { createContext, useState } from "react";
import { PropTypes } from "prop-types";

export const AppContext = createContext();

export const AppContextProvider = (props) => {
  // this state will be shared with all components
  const [notifState, setNotifState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    severity: "success",
    msg: "",
  });

  const openNotif = (newState) => {
    setNotifState({ open: true, ...newState });
  };

  return (
    <AppContext.Provider value={[openNotif, notifState]}>
      {props.children}
    </AppContext.Provider>
  );
};

AppContextProvider.propTypes = {
  children: PropTypes.any,
};
